// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__a+kHR","slideContainer":"Switch_slideContainer__UlEdm","slide":"Switch_slide__jXRFk","input":"Switch_input__iLqt+"};